<template>
  <bxp-form-framework
    sidebar-background="https://mark-cdn.bountixp.com/marketing-v2/wp-content/uploads/2019/10/bountixp-free-trial-sidebar.jpg"
  >
    <template v-slot:sidebar-primary-text>
      <strong>Plans to suit any size team </strong>
    </template>
    <template v-slot:sidebar-secondary-text>
      Get bountiXP <strong>Professional FREE for 14 days.</strong> You can downgrade or upgrade your trial plan at any time. Find a perfect fit, no credit card required. Have a question? Not sure which plan is right for you, or do you need a <a href="/start-conversation?cta=free_trial_form_sidebar">custom quote</a>?
    </template>
    <template v-slot:sidebar-sub-text>
      (No credit card required)
    </template>
    <template v-slot:main-content>
      <router-view></router-view>
    </template>
  </bxp-form-framework>
</template>

<script>
import { formBus } from "@/formBus";
export default {
  name: "app",
  data() {
    return {

    }
  }
};
</script>

<style>

</style>
